import { useQuery } from '@tanstack/react-query';
import type { ReactElement } from 'react';

import { useAuth } from '@/app/auth/context';
import { EmptyState, ErrorState, SkeletonRows } from '@/components/admin/states';
import { fetchThreads } from '@/features/messages/api';
import { ThreadConversation } from '@/features/messages/ThreadConversation';

/** イベント詳細の「グループメッセージ」タブ. 公開時に自動生成されるグループを表示する（M8・D-131）. */
export function EventMessagesTab({ eventId }: { eventId: string }): ReactElement {
  const { user } = useAuth();
  const query = useQuery({
    queryKey: ['threads', 'event_group'],
    queryFn: () => fetchThreads('event_group'),
  });

  if (query.isPending) return <SkeletonRows rows={3} />;
  if (query.isError) {
    return (
      <ErrorState message="メッセージの取得に失敗しました。" onRetry={() => void query.refetch()} />
    );
  }

  const thread = query.data.find((t) => t.event_id === eventId);
  if (!thread || !user) {
    return (
      <EmptyState
        title="このイベントのグループスレッドはありません"
        description="公開済みイベントで対象者がいる場合、自動的にグループスレッドが作成されます。"
      />
    );
  }

  return <ThreadConversation threadId={thread.id} currentUserId={user.id} />;
}
